/* istanbul ignore file */
import React, { useEffect, useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import styled from 'styled-components';
import SahamDrawer from 'components/SahamDrawer';
import { translate } from 'containers/services/translate';
import messages from 'containers/PreOpeningPage/messages';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import { Listings } from 'containers/AppContainer/typings';
import recapManagerMessages from 'containers/RecapManagerPage/messages';
import { get, isEmpty } from 'lodash';
import { toast } from 'react-toastify';
import AddOpposingParty from 'containers/PreOpeningPage/OpposingParty/AddOpposingParty';
import { CHOICE } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/constants';
import OpposingPartyRecap from 'containers/PreOpeningPage/OpposingParty/OpposingPartyRecap';
import OpposingPartyCheckbox from 'containers/PreOpeningPage/OpposingParty/OpposingPartyCheckbox';
import { CLAIM_STATUS } from 'containers/data-structure';

export interface OpposingPartyDrawerProps {
  intl: IntlShape;
  open: boolean;
  handleToggleDrawer: Function;
  listings: Listings;
  setClaimRecap?: Function;
  data: any;
  requestUpdateVehicleInfo?: Function;
  policyInfo?: { sagis: {} };
  requestCreateVehicle?: Function;
  handleAddOpposingParty?: Function;
  sagisOpposingParties: any;
}
const Container = styled.div`
  .fields {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    margin-bottom: 10px;
    height: 500px;
  }
  .input {
    width: 327px;
    margin-bottom: 20px;
    margin-left: 24px;
    margin-right: 24px;
  }
`;

const AddOpposingPartyDrawer: React.FC<OpposingPartyDrawerProps> = ({
  listings,
  data,
  ...props
}): JSX.Element => {
  const [toggleOpen, setToggleOpen] = React.useState(false);
  const [hasMaterialDammage, setHasMaterialDammage] = useState<string | null>(
    null,
  );
  const [addedVehicle, setAddedVehicle] = React.useState({});

  const [expandedOpposingRecap, setExpandedOpposingRecap] = React.useState<
    boolean[]
  >([]);
  const [renderSubForm, setRenderSubForm] = React.useState<boolean>(true);

  useEffect(() => {
    if (!isEmpty(data.vehicules)) setHasMaterialDammage('YES');
  }, [data?.opposingParty?.newVehicles, data.vehicules]);
  const handleSuccessCallback = () => {
    toast.success(translate(messages.successAddVehicles, props));
  };
  const handleCreateVehicle = () => {
    if (
      props.requestCreateVehicle &&
      get(addedVehicle, 'opposingParty.newVehicles')
    ) {
      const formatedVehiclesToAdd = get(
        addedVehicle,
        'opposingParty.newVehicles',
      ).map((element: any) => ({
        ...element,
        claimId: get(addedVehicle, 'claim.id', ''),
        decision: {
          status: 'PENDING',
        },
      }));

      props.requestCreateVehicle(
        {
          vehicles: formatedVehiclesToAdd,
          claimId: get(addedVehicle, 'claim.id', ''),
          claimDetails: {
            status: CLAIM_STATUS.PENDING_INFO_MODIFICATION,
          },
        },
        handleSuccessCallback,
      );
      props.handleToggleDrawer();
    }
  };
  const handleCloseDrawer = () => {
    props.handleToggleDrawer();
    props.setClaimRecap &&
      props.setClaimRecap(
        Object.assign(
          {},
          { ...data },
          {
            opposingParty: {
              hasMaterialDammage,
              vehicules: get(data, 'opposingParty.vehicules'),
              newVehicles: [],
            },
          },
        ),
      );
  };
  return (
    <SahamDrawer
      open={props.open}
      handleToggleDrawer={handleCloseDrawer}
      title={translate({ ...messages.opposingPartyCardTitle }, props)}
      confirmButtonTitle={translate(
        recapManagerMessages.drawerSaveFormButtonTitle,
        props,
      )}
      handleValidateDrawer={handleCreateVehicle}
    >
      {isEmpty(data.vehicules) && (
        <OpposingPartyCheckbox
          hasMaterialDammage={hasMaterialDammage}
          setHasMaterialDammage={(value: any) => {
            setHasMaterialDammage(value);
            if (value === CHOICE.YES) {
              setRenderSubForm(true);
            } else {
              setRenderSubForm(false);
            }
          }}
          claimToPreopen={data}
          setClaimToPreopen={setAddedVehicle}
          opposingPartyValidation={{}}
        />
      )}
      {hasMaterialDammage === CHOICE.YES && (
        <div style={{ padding: 10 }}>
          {!isEmpty(get(addedVehicle, 'opposingParty.newVehicles', [])) &&
            get(
              addedVehicle,
              'opposingParty.newVehicles',
            ).map((el: Vehicule, index: number) => (
              <OpposingPartyRecap
                listings={listings}
                vehicule={el}
                index={index}
                claimToPreopen={data}
                setClaimToPreopen={setAddedVehicle}
                expanded={expandedOpposingRecap}
                setExpanded={setExpandedOpposingRecap}
                setRenderForm={setRenderSubForm}
                setToggleOpen={setToggleOpen}
                isForDrawer={true}
                sagisOpposingParties={props.sagisOpposingParties}
              />
            ))}
          <>
            {!toggleOpen && (
              <Container>
                <div className="fields">
                  <AddOpposingParty
                    listings={listings}
                    claimToPreopen={data}
                    setClaimToPreopen={setAddedVehicle}
                    setClaimRecap={props.setClaimRecap}
                    toggleOpen={toggleOpen}
                    setToggleOpen={setToggleOpen}
                    renderSubForm={renderSubForm}
                    isForDrawer={true}
                  />
                </div>
              </Container>
            )}
          </>
        </div>
      )}
    </SahamDrawer>
  );
};

export default injectIntl(AddOpposingPartyDrawer);
